export default {
  'no-recipes': 'Aucune recette trouvée pour ce type',
};
